/**
 * Created by andrey on 11.02.2021.
 */

const QuestsGroupIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.quests_icon_json,
        control: "QuestsGroupIcon"
    });

    this.activeInfoView = undefined;
    this.canShowInfoView = true;

    cleverapps.inputDispatcher.on("pointerdown", this.handleClickOutside.bind(this));
    cleverapps.inputDispatcher.on("mousescroll", this.handleClickOutside.bind(this));
    cleverapps.inputDispatcher.on("pointermove", this.hideInfo.bind(this));

    this.onGetIconViewListener = function () {};
    this.onGetView = function () {};

    Map2dLocation.currentLocation && Map2dLocation.currentLocation.map.on("onPositionChanged", this.hideInfo.bind(this), this);
    Map2dLocation.currentLocation && Map2dLocation.currentLocation.on("onAnimateZoom", this.hideInfo.bind(this), this);
};

QuestsGroupIcon.prototype = Object.create(SideBarIcon.prototype);
QuestsGroupIcon.prototype.constructor = QuestsGroupIcon;

QuestsGroupIcon.prototype.resetState = function () {
    this.available = QuestsGroupIcon.IsAvailable();
    if (this.available) {
        this.setAttention(Map2dLocation.currentLocation.quests.hasAttention());
    }
};

QuestsGroupIcon.prototype.onPressed = function (iconView) {
    if (!this.activeInfoView || this.activeInfoView.questIcon !== iconView) {
        this.showInfo(iconView.quest, { iconView });
    }
};

QuestsGroupIcon.prototype.allowInfoView = function () {
    this.canShowInfoView = true;
};

QuestsGroupIcon.prototype.denyInfoView = function () {
    this.canShowInfoView = false;
    this.hideInfo();
};

QuestsGroupIcon.prototype.hideInfo = function () {
    if (this.activeInfoView) {
        this.activeInfoView.hide();
        delete this.activeInfoView;
    }
};

QuestsGroupIcon.prototype.showInfo = function (quest, options) {
    this.hideInfo();

    if (!this.canShowInfoView) {
        return;
    }

    const ViewCtor = QuestsWindow.IsAvailable() ? QuestNotificationView : QuestInfoView;
    const questInfoView = new ViewCtor(quest, options, this);
    this.onGetView().addChild(questInfoView);

    addCleaner(questInfoView, () => {
        if (this.activeInfoView === questInfoView) {
            delete this.activeInfoView;
        }
    });

    this.activeInfoView = questInfoView;
};

QuestsGroupIcon.prototype.getForce = function () {
};

QuestsGroupIcon.prototype.getView = function () {
    return QuestsGroupIconView;
};

QuestsGroupIcon.prototype.countOfSlots = function () {
    return 2;
};

QuestsGroupIcon.prototype.onShow = function () {
    this.allowInfoView();
};

QuestsGroupIcon.prototype.onHide = function () {
    this.denyInfoView();
};

QuestsGroupIcon.prototype.clearListeners = cleverapps.extendFunc(QuestsGroupIcon.prototype.clearListeners, function (...args) {
    this._super(...args);

    this.onGetIconViewListener = function () {};
    runCleaners(this);
});

QuestsGroupIcon.prototype.handleClickOutside = cleverapps.accumulate(0, function (touch) {
    if (this.activeInfoView && !this.activeInfoView.isCompletion()) {
        const isClickToInfoView = cc.rectContainsPoint(cc.rect(0, 0, this.activeInfoView.width, this.activeInfoView.height), this.activeInfoView.convertTouchToNodeSpace(touch));

        const icon = this.activeInfoView.questIcon;
        const isClickToIcon = cc.rectContainsPoint(cc.rect(0, 0, icon.width, icon.height), icon.convertTouchToNodeSpace(touch));

        if (!isClickToInfoView && !isClickToIcon) {
            this.activeInfoView.hide();
            delete this.activeInfoView;
        }
    }
});

QuestsGroupIcon.IsAvailable = function () {
    return Map2dLocation.currentLocation && Map2dLocation.currentLocation.quests && Map2dLocation.currentLocation.quests.config && cleverapps.meta.selectedLocationId() !== "collections" && !QuestsWindow.IsAvailable();
};
